import { Routes } from '@angular/router';
import { noAuthGuard } from './core/auth/no-auth.guard';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  {
    path: 'login',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./features/auth/login/login').then(m => m.LoginComponent),
  },

  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shared/layouts/top-navbar/top-navbar.component').then(m => m.TopNavbarComponent),
    children: [
      {
        path: 'availability',
        loadComponent: () =>
          import('./features/teacher/availability/teacher-dashboard').then(m => m.TeacherDashboardComponent),
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];